export default {
	VALUE: "VALUE",
	FIELD: "FIELD"
};
